import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-education',
//   templateUrl: './education.component.html',
//   styleUrls: ['./education.component.css']
// })
// export class EducationComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { FormService } from "../../services/form/form.service";
import { InquiryService } from "../../services/inquiry/inquiry.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/language/language.service";

declare var jQuery: any;
declare var $: any;


@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css']
})
export class EducationComponent implements OnInit {
  public coursesForm: FormGroup;
  public contactForm: FormGroup;
  public contactEventForm: FormGroup;

  // public countries: any[] = [];
  public genders: any[] = [];
  public zones: any[] = [];

  public courses: any[] = [];
  public subcoursesofcourse: any[] = [];
  public subcourseslist: any[] = [];
  public subcoursedetail: any[] = [];

  public responseData;

  public status;
  public msgSuccess;
  public msgSuccessEvent;
  public msgWarning;
  public msgWarningEvent;
  public msgInfo;
  public message;
  public cDescription: any = [];

  public contact_us_header;
  public inquery_txt_caps;
  public submit_btn_txt_caps;
  public something_wrong_txt;
  public message_sent_txt;
  public result;
  public draw;
  public totalRecords;
  public filterdRecords;

  public name: string;
  public contact: string;
  public course: string;
  public zone: string;
  public city: string;
  public subcourse: string;
  public referred: string;
  public others: string;
  public email: string;
  public agree: string;
  public number: number;

  public dreamCourses: string;

  errors: any;

  checkModel = false;

  public formErrors = {
    name: "",
    contact: "",
    zone: "",
    city: "",
    course: "",
    subcourse: "",
    referred: "",
    others: "",
    email: "",
    agree: "",
    message: "",
    number: "",

    dreamCourses: "",
  };

  public formEventErrors = {
    name: "",
    // email: "",
    message: "",
    number: "",
  };

  subcoursedetails: any = "about";
  verifyMobileNumber: any = false;
  verifyOTP: any = false;
  verifiedContactNumber: any = false;
  resData: any;
  usrOTP: number;
  wrongOTP: any = false;
  contactNumber : any;
  referalName:any;
  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private inquiryService: InquiryService,
    //private router: Router,
    private router: Router, private route: ActivatedRoute,
    private translate: TranslateService,
    public languageService: LanguageService
  ) {
    this.name = "";
    this.email = "";
    this.contact = "";
    (this.zone = null), (this.city = "");
    this.course = null;
    this.subcourse = null;
    this.referred = "";
    this.others = "";

    this.agree = "";

    this.message = "";

    this.dreamCourses;
    this.createForm();
    this.createEventForm();
    this.getZones();
    this.getCourses();
  }

  ngOnInit() {
    // this.router.navigate(['thankyou']);
    this.route.params.subscribe((params: Params)=> console.log(params['refer']))
    console.log(this.router.url);
    let checkThirdParty = this.router.url.split('=');
    console.log(checkThirdParty);
    if(checkThirdParty.length > 1){
      this.referalName = checkThirdParty[1];
    }else{
      this.referalName = "Pacific";
    }

  }

  public createForm() {
    this.contactForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required])],
      email: [this.email, Validators.compose([Validators.required])],
      contact: [this.contact, Validators.compose([Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)])],
      zone: [this.zone, Validators.compose([Validators.required])],
      city: [this.city, Validators.compose([Validators.required])],
      course: [this.course, Validators.compose([Validators.required])],
      subcourse: [this.subcourse, Validators.compose([Validators.required])],
      referred: [this.referred],
      // others: [this.others],
      agree: [this.agree, Validators.compose([Validators.required])],
    });

    this.contactForm.valueChanges.subscribe((data) => {
      this.formErrors = this.formService.validateForm(
        this.contactForm,
        this.formErrors,
        true
      );
    });
  }

  public createEventForm() {
    this.contactEventForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required])],
      // email: [this.email, Validators.compose([Validators.required])],
      number: [this.number, Validators.compose([Validators.required])],
      message: [this.message, Validators.compose([Validators.required])],
    });

    this.contactEventForm.valueChanges.subscribe((data) => {
      this.formEventErrors = this.formService.validateForm(
        this.contactEventForm,
        this.formEventErrors,
        true
      );
    });
  }

  submitForm() {

    this.formService.markFormGroupTouched(this.contactForm);
    this.contactForm.value.referred = this.referalName;

    //console.log(this.contactForm);

    // this.contactForm.controls['refered'].setValue(this.referalName);
    // if (this.contactForm.valid && this.verifiedContactNumber == true) {

      if (this.contactForm.valid) {
        //alert('if');
        // this.inquiryService.sendDetails(this.contactForm.value , this.contactNumber).subscribe(
        this.inquiryService.sendDetails(this.contactForm.value).subscribe(
        (response) => {
          this.responseData = response;
          this.status = this.responseData.status;
          this.message = this.responseData.message;

          if (!this.status) {
            this.msgSuccess = "";
            this.msgWarning = "Something went wrong please try again later.";
            if (this.responseData.result) {
              this.responseData.result.forEach((element) => {
                if (element.id == "name") {
                  this.formErrors.name = element.text;
                }
                if (element.id == "email") {
                  this.formErrors.email = element.text;
                }
                if (element.id == "contact") {
                  this.formErrors.contact = element.text;
                }
                if (element.id == "zone") {
                  this.formErrors.zone = element.text;
                }
                if (element.id == "city") {
                  this.formErrors.city = element.text;
                }
                if (element.id == "course") {
                  this.formErrors.course = element.text;
                }
              });
            }
          } else {
            this.msgWarning = "";
            this.msgSuccess = "Thank you for apply.";
            // this.router.navigate(['thankyou']);
            setTimeout(() => {
              this.router.navigate(['thankyou']);
          }, 3000);
          //  this.router.navigate(['home']);
            this.contactForm.reset();
            this.verifiedContactNumber = false;
            this.contactForm.controls["contact"].enable();
          }
        },
        (err) => {
          console.error(err);
        }
      );
    } else {
      //alert('else');
      this.formErrors = this.formService.validateForm(
        this.contactForm,
        this.formErrors,
        false
      );
      this.formErrors.agree =
        "You must agree to the terms and conditions before apply.";
    }
  }
  
  submitEventForm() {
    //alert("Event Form");
    this.formService.markFormGroupTouched(this.contactEventForm);

    console.log(this.contactEventForm);

    this.contactEventForm.value.referred = this.referalName;
    
    if (this.contactEventForm.valid) {
      this.inquiryService.sendEventDetails(this.contactEventForm.value).subscribe(
        (response) => {
          this.responseData = response;
          this.status = this.responseData.status;
          this.message = this.responseData.message;

          console.log(this.responseData);

          if (!this.status) {
            this.msgSuccessEvent = "";
            this.msgWarningEvent = "Something went wrong please try again later.";
            if (this.responseData.result) {
              this.responseData.result.forEach((element) => {
                if (element.id == "name") {
                  this.formEventErrors.name = element.text;
                }
                if (element.id == "number") {
                  this.formEventErrors.number = element.number;
                }
                if (element.id == "message") {
                  this.formEventErrors.message = element.text;
                }
              });
            }
          } else {
            this.msgWarningEvent = "";
            this.msgSuccessEvent = "Thank you for apply.";
            setTimeout(() => {
              this.router.navigate(['thankyou']);
          }, 3000);

            this.contactEventForm.reset();
            this.verifiedContactNumber = false;
          }
        },
        (err) => {
          console.error(err);
        }
      );

    } else {
      this.formEventErrors = this.formService.validateForm(
        this.contactEventForm,
        this.formEventErrors,
        false
      );
    }
  }


  getZones() {
    this.zones = [];
    this.inquiryService.getZoneslist().subscribe(
      (response) => {
        this.result = response;
        this.totalRecords = this.result.recordsTotal;
        this.filterdRecords = this.result.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.zones.push({
            id: this.result.data[index].id,
            country: this.result.data[index].country,
            name: this.result.data[index].name,
            code: this.result.data[index].code,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getCourses() {
    this.courses = [];

    this.inquiryService.getEductaioncourselist().subscribe(
      (response) => {
        this.result = response;
        this.draw = response.draw;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.courses.push({
            id: this.result.data[index].id,
            name: this.result.data[index].name,
            description: this.result.data[index].description,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getSubcourses(category_id) {
    this.subcoursesofcourse = [];

    this.inquiryService.getSubcourseslist(category_id).subscribe(
      (response) => {
        this.result = response;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.subcoursesofcourse.push({
            id: this.result.data[index].id,
            course_id: this.result.data[index].course_id,
            name: this.result.data[index].name,
            about: this.result.data[index].about,
            contact: this.result.data[index].contact,
            duration: this.result.data[index].duration,
            eligibility: this.result.data[index].eligibility,
            scholarship: this.result.data[index].scholarship,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }



  getGender() {
    this.genders = [];

    this.inquiryService.getGenderlist().subscribe(
      (response) => {
        this.result = response;
        this.draw = response.draw;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.genders.push({
            id: this.result.data[index].id,
            title: this.result.data[index].title,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  isTermProvided(event: any) {
    this.checkModel = event.target.checked;
  }

  getDescriptiopn(sub_course_id) {
    this.inquiryService.getSubcourseDetail(sub_course_id).subscribe(
      (response) => {
        this.result = response;
        this.subcoursedetail = response.result;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  onChange(value) {
    this.subcoursedetails = value;
  }

  youTube(value) {
    window.open(value);
  }

  mobileNoVerify() {
    this.contactNumber = this.contactForm.value.contact;
    if (this.contactForm.value.contact.toString().length >= 10) {
      this.verifyMobileNumber = true;
    }
  }
  sendOTP() {
    this.verifyMobileNumber = false;
    this.usrOTP = Math.floor(100000 + Math.random() * 900000);
    this.verifyOTP = true;
    this.inquiryService
      .sendOTP(this.usrOTP, this.contactForm.value.contact)
      .subscribe((response) => {});
  }
  verified(data) {
    if (data.target.value == this.usrOTP) {
      this.verifiedContactNumber = true;
      this.verifyOTP = false;
      this.contactForm.controls["contact"].disable({ onlySelf: true });
    } else if (data.target.value.length == 6) {
      this.wrongOTP = true;
    }
  }
}

